import { AppBox, AppGridBox, AppPaper, AppText, AppTitle } from "..";
import { TextColors } from "../../types/core-types";

type CardOrientation = "horizontal" | "vertical";

export interface NewsCardProps {
  orientation?: CardOrientation;
  thumbnail: string;
  title: string;
  label: string;
  titleColor?: TextColors;
}

export default function NewsCard({
  orientation = "vertical",
  thumbnail,
  title,
  label,
  titleColor,
}: NewsCardProps) {
  return (
    <AppPaper
      style={{ overflow: "hidden", width: "100%" }}
      shadow="xs"
      padding="none"
      radius="md"
    >
      <AppBox
        flexDirection={orientation === "vertical" ? "column" : "row"}
        alignItems="left"
      >
        <AppGridBox
          className={orientation === "horizontal" ? "news-card-min" : ""}
          style={
            orientation === "horizontal"
              ? { gridTemplateColumns: "1fr 2fr" }
              : {}
          }
        >
          <AppBox>
            <img style={{ width: "100%" }} alt={title} src={thumbnail} />
          </AppBox>
          <AppBox flexDirection="column" p="xs">
            <AppGridBox gap="3xs">
              <AppTitle
                size="md"
                color={titleColor}
                textAlign="left"
                lineClamp={2}
              >
                {title}
              </AppTitle>
              <AppText as="p" size="sm" color="muted" lineClamp={2}>
                {label}
              </AppText>
            </AppGridBox>
          </AppBox>
        </AppGridBox>
      </AppBox>
    </AppPaper>
  );
}
